/**
 * Created by nkarnik on 8/2/2016.
 */
import React, {Component} from 'react';
import ReactHighcharts from 'react-highcharts';

export default class LineChart extends Component {
    createConfig(data) {
        var config = {
            title: {
                text: null
            },
            line: {
                connectNulls: false
            },
            yAxis: {
                title: {
                    text: data.yAxis.names[0]
                },
                plotLines: [{
                    value: 0,
                    width: 1,
                    color: '#808080'
                }]
            },
            xAxis: {
                title: {
                    text: data.xAxis.name
                }
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            chart: {
                height: 700
            },
        };

        return config;
    }

    render(){
        let config = this.createConfig(this.props.data);
        return (
            <ReactHighcharts ref="hc" config={config} />
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Highcharts/LineChart.js
 **/